module.exports = __webpack_public_path__ + "static/media/BM_ManageTeam.96937648.svg";